<template>




  <div class="card card-widget card-contacts">
    <div class="card-header">
      <h6 class="mg-b-0">Newest Members</h6>
      <nav class="nav">
        <a href=""><i data-feather="help-circle"></i></a>
        <a href=""><i data-feather="more-vertical"></i></a>
      </nav>
    </div><!-- card-header -->
    <div class="card-body pd-0">
      <ul v-for="(contact) in contacts" :key="contact.id" :id="'row-'+contact.id" class="list-group list-group-flush">
        <li class="list-group-item">
          <div class="avatar">
            <span :class="getRandomColor()"> {{ getFirstString(contact.first_name) }}</span>
          </div>
          <div class="list-body">
            <h6>
              <span v-if="(contact.first_name + contact.middle_name + contact.last_name).length<35">{{ contact.first_name }} {{
                  contact.middle_name
                }} {{ contact.last_name }}</span>
              <span v-else>{{
                  (contact.first_name + ' ' + contact.middle_name + ' ' + contact.last_name).substring(0, 22) + "..."
                }}</span>
            </h6>
            <p> Mobile: {{ contact.phone_number }} </p>
          </div>

          <div class="mg-l-auto d-flex align-self-center">
            <nav class="nav nav-icon-only">
              <a :href="`/users/${contact.id}`" class="nav-link d-none d-sm-block"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-mail"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path><polyline points="22,6 12,13 2,6"></polyline></svg></a>
              <a :href="`/users/${contact.id}`" class="nav-link d-none d-sm-block"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-slash"><circle cx="12" cy="12" r="10"></circle><line x1="4.93" y1="4.93" x2="19.07" y2="19.07"></line></svg></a>
              <a :href="`/users/${contact.id}`" class="nav-link d-none d-sm-block"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-user"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg></a>
            </nav>
          </div>
        </li>
      </ul>
    </div><!-- card-body -->
    <div class="card-footer bg-transparent">
      <a :href="`/users?sort=first_attendance,desc&size=15`" class="link-03 d-flex align-items-center gap-1">View All Contacts <ion-icon name="arrow-forward-outline"></ion-icon></a>
    </div><!-- card-footer -->
  </div>




<!--  <div class="card-header d-flex align-items-center justify-content-between pd-r-10">-->
<!--    <h6 class="mg-b-0">Newest Members</h6>-->
<!--    <div class="d-flex align-items-center tx-16">-->
<!--      <a href="" class="link-03 lh-0">-->
<!--        <ion-icon name="reload-outline"></ion-icon>-->
<!--      </a>-->
<!--      <a href="" class="link-03 lh-0 mg-l-5">-->
<!--        <ion-icon name="ellipsis-vertical"></ion-icon>-->
<!--      </a>-->
<!--    </div>-->
<!--  </div>-->

<!--  <ul v-for="(contact) in contacts" :key="contact.id" :id="'row-'+contact.id" class="list-group list-group-flush tx-13">-->
<!--    <li class="list-group-item d-flex pd-sm-x-20">-->
<!--      <div class="avatar">-->
<!--        <span :class="getRandomColor()"> {{ getFirstString(contact.first_name) }}</span>-->
<!--      </div>-->
<!--      <div class="pd-l-10">-->
<!--        <p class="tx-medium mg-b-0">-->
<!--          <span v-if="(contact.first_name + contact.middle_name + contact.last_name).length<35">{{ contact.first_name }} {{-->
<!--              contact.middle_name-->
<!--            }} {{ contact.last_name }}</span>-->
<!--          <span v-else>{{-->
<!--              (contact.first_name + ' ' + contact.middle_name + ' ' + contact.last_name).substring(0, 22) + "..."-->
<!--            }}</span>-->
<!--        </p>-->
<!--        <small class="tx-12 tx-color-03 mg-b-0">Mobile: {{ contact.phone_number }}</small>-->
<!--      </div>-->
<!--      <div class="mg-l-auto d-flex align-self-center">-->
<!--        <nav class="nav nav-icon-only">-->
<!--          <a :href="`/users/${contact.id}`" class="nav-link d-none d-sm-block"><i data-feather="mail"></i></a>-->
<!--          <a :href="`/users/${contact.id}`" class="nav-link d-none d-sm-block"><i data-feather="slash"></i></a>-->
<!--          <a :href="`/users/${contact.id}`" class="nav-link d-none d-sm-block"><i data-feather="user"></i></a>-->
<!--          <a :href="`/users/${contact.id}`" class="nav-link d-sm-none"><i data-feather="more-vertical"></i></a>-->
<!--        </nav>-->
<!--      </div>-->
<!--    </li>-->
<!--  </ul>-->

<!--  <div class="card-footer text-center tx-13">-->
<!--    <a :href="`/users?sort=first_attendance,desc&size=15`" class="link-03 d-inline-flex align-items-center">View All Members-->
<!--      <ion-icon name="arrow-down-outline" class="tx-12 mg-b-2"></ion-icon>-->
<!--    </a>-->
<!--  </div>-->

</template>

<script>

import serviceMixin from "@/mixins/contact-service";

export default {
  name: "NewMembers",
  components: {},
  mixins: [serviceMixin],
  watch: {},
  data() {
    return {
      contacts: [],
      colors: ['bg-info','bg-primary','bg-indigo','bg-gray-800','bg-black','bg-facebook','bg-pink','bg-teal','bg-twitter','bg-secondary']
    }
  },
  created() {
    this.loadData();
  },
  methods: {
    async loadData() {

      let url = await this.buildQueryParam(this.page, this.first_name, this.middle_name,
          this.last_name, this.email, this.birthday_month,
          this.marital_status, this.wofbi_status, this.water_baptism,
          this.service_unit, this.attendance_month, this.attendance_year, 6, "first_attendance");

      let result = await this.getContacts(url);

      if (result.data) {
        this.contacts = this.$store.state.contact_list;
      } else {
        this.contacts = [];
      }
    },

    getRandomColor() {
      return `avatar-initial rounded-circle ${this.colors[Math.floor(Math.random() * this.colors.length)]}`;
    },

    getFirstString(data) {
      return data.charAt(0).toUpperCase();
    }
  }
}
</script>



